<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Institutional Sales</span>
    </div>
    <div class="button-group">
      <app-ticketing-info></app-ticketing-info>
    </div>
  </div>

  @if (isUploaded !== true) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Add Institutional Sales</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="downloadMyFile()"
            type="button"
          >
            Download Sample Excel Template
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <form [formGroup]="fileNameForm" novalidate>
          <div class="form-section">
            <!-- Institutional Sales File Upload -->
            <div class="form-group">
              <label for="fileName" class="form-label"
                >Institutional Sales File Upload</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Institutional Sales File Upload</mat-label>

                <!-- Display File Name or Placeholder -->
                <input
                  matInput
                  type="text"
                  formControlName="fileName"
                  [value]="fileNameForm.controls['fileName'].value"
                  readonly
                />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".xlsx"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                <!-- Error Message -->
                @if (
                  fileNameForm.controls['fileName'].touched &&
                  fileNameForm.controls['fileName'].errors?.required
                ) {
                  <mat-error> This field is Mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <p class="warning">
            * For better performance please limit the records upto 500.
          </p>
        </form>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          <button
            type="button"
            [disabled]="!file"
            class="edit-button"
            (click)="saveInstitutionalSalesDetails($event)"
          >
            Upload <mat-icon class="btn-icon">edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
  @if (isUploaded === true) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">
          Institutional Sales Uploaded Files Response
        </h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="DownloadOutputReport()"
            [disabled]="Responses.length === 0"
            type="button"
          >
            Download Report
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>VIN NO</th>
              <th>TICKET NO</th>
              <th>Status</th>
              <th>Errors</th>
            </tr>
          </thead>
          @if (totalLength !== 0) {
            <tbody>
              @for (
                response of Responses
                  | paginate
                    : {
                        id: 'paginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track response
              ) {
                <tr>
                  <td>{{ response.VIN_NO }}</td>
                  <td>{{ response.TICKET_NO || '--' }}</td>
                  <td>{{ response.message }}</td>
                  <td>
                    {{
                      response.VALIDATION_ERROR.length === 0
                        ? 'No errors'
                        : response.VALIDATION_ERROR
                    }}
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                    tabindex="0"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
